<section class="content profile-page">
  <div class="block-header">
      <div class="">
          <div class="row ">
              <div class=" col-md-12 px-6 col-sm-12 p-0">
                  <h2 class="poppins font-weight-bold">Welcome to FastSwiff
                   </h2>
              </div> 
          </div>
      </div>
     
  </div>    
  <div class="  ">
      <div class="row" style="padding-top: 65px;">
          <div class="col-md-12">
              <div> 
                  <div class=" card px-5 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                      <div class="row mx-0">
                          <div class="col-md-3">
                              <div class="">
                                  <div class=" " *ngIf="MerchantLogo">
                                      <img   src="data:image/jpeg;base64,{{content}}" fxFlexAlign="center"id="merchatImage" class="profile fade-in-on-icon-sidenav img-thumbnail img-rounded">
                                  </div>
                                  <div class=" "   *ngIf="PaygLogo">
                                      <img   src="assets/img/user/10.jpg"   class="profile fade-in-on-icon-sidenav img-thumbnail img-rounded">
                                  </div>
                                  <a class="d-block py-2" [routerLink]="'/settings/merchantsettings'"> Change Logo</a>
                              </div>
                          </div>
                          <div class="col-md-9 p-0">
                             
                              <h3 class="m-0 poppins font-weight-bold">   {{businessName}} </h3>
                              <div class="row pt-2">
                                  <div class="col-md-6">
                                      <p > <span class="text-muted">BusinessName:  {{businessName}} </span></p>
                                      <p > <span class="text-muted">MerchantKeyId:   {{merchantKeyId}} </span></p>
                                        <p ><span class="text-muted">UserName:   {{username}}</span> </p>  
                                </div>
                                <div class="col-md-6">
                             
                            
                                  <p>
                                      <img src="assets/img/email-icon.png" alt="" > &nbsp;<span class="text-muted">Email:  care@fastswiff.com</span>
                                      </p>
                                  <p>
                                      <img src="assets/img/phone-icon.png" alt="" > &nbsp;<span class="text-muted ">Phone: <span  class="robot" style="font-weight: 400;">+917337327109</span></span>
                                      </p>
                              </div>
                              </div>
                          </div>
                      </div> 
                  </div>
                
                 
                  </div>
              </div>
      </div>
      <div class="row"> 
          <div class="col-md-12">
              <div class=" card px-5 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                  <div class="row">
                      <div class="col-md-3">

                              <a   class="welcome-btn d-block pb-2 text-center btn-welcome"  [style.background-color]="selected == 3 ? '#d40055' : '#e1f3f3'" (click)=" gotoPayout(3)">PayOut</a> 
                         
                      </div>
                     
                     
                     
                
                      <div class="col-md-3"  >
                          <h4>New</h4>
                          <a  class="welcome-links" [routerLink]="['/PayOut/NewPayOutContact']">
                                PayOut Contact
                          </a> 
                       
                          <a class="welcome-links" [routerLink]="['/PayOut/AccountBalance']">
                                Account Balance
                          </a>
                      </div>
                      <div class="col-md-3"> 
                              <h4>Manage</h4>
                              <a [routerLink]="['/PayOut/ManagePayOutContact']"  class="welcome-links"> 
                                 Manage PayOut Contact
                              </a> 
                              <!-- <a [routerLink]="['/PayOut/ManageVirtualAccount']"  class="welcome-links"> 
                                      Manage Virtual Account Info
                              </a>  -->
                              <a [routerLink]="['/PayOut/PayoutLedgers']"  class="welcome-links"> 
                                      Payout Ledger
                              </a> 
                              <a [routerLink]="['/PayOut/PayOutTransactions']"  class="welcome-links"> 
                                      PayOut Transactions
                              </a>  
                              <a [routerLink]="['/PayOut/PayOutBatches']"  class="welcome-links"> 
                                  PayOut Settlements
                          </a>  
                                 
                              
                      </div>
                    
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>




